export class QuestionerList {
    constructor() {
        this.questions = null;
        this.current = null;
    }

    static create(questions, current) {
        return Object.assign(new QuestionerList(), {questions, current});
    }

    get length() {
        return this.questions.length;
    }

    get first() {
        return this.questions[0];
    }

    get isLast() {
        return this.index(this.current) === this.length - 1;
    }

    get isFirst() {
        return this.index(this.current) === 0;
    }

    setCurrent(question) {
        this.current = question;
    }

    index(question) {
        return this.questions.indexOf(question);
    }

    prev() {
        const index = this.index(this.current) - 1;

        this.setCurrent(this.questions[index]);
    }

    next() {
        const index = this.index(this.current) + 1;

        this.setCurrent(this.questions[index]);
    }
}